export default __webpack_public_path__ + "static/media/Happy.08e3f0cc.png";